import React from "react"
import { default as Layout } from "../templates/LayoutAuth"

import TechStack from "../large/TechStack"

const Login = props => (
  <Layout>
    <TechStack />
  </Layout>
)

export default Login



// WEBPACK FOOTER //
// ./src/pages/Stack.js